import { render, staticRenderFns } from "./HistoricoPontosSig.vue?vue&type=template&id=38d57182&scoped=true&"
import script from "./HistoricoPontosSig.vue?vue&type=script&lang=js&"
export * from "./HistoricoPontosSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d57182",
  null
  
)

export default component.exports